var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.col1))]),_c('th',[_vm._v(_vm._s(_vm.col2))]),_c('th',[_vm._v(_vm._s(_vm.col3))]),_c('th',[_vm._v(_vm._s(_vm.col4))]),_c('th',[_vm._v(_vm._s(_vm.col5))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0c938e0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/table/TableHeadFive.vue
// module id = null
// module chunks = 